import { css } from '@emotion/react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { type FC } from 'react';
import {
  ContextMenuComponent, ContextMenuDefaultItem, ContextMenuItemCoreComponent,
} from '~/_shared/baseComponents/contextMenu';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { useTranslation } from '~/_shared/utils/hooks';

const menuTriggerStyle = ({ x, y }: {x: number; y: number}) => css({
  position: 'absolute',
  top: y,
  left: x,
});

const menuItemStyle = css({
  fontSize: '12px',
  display: 'flex',
  justifyContent: 'space-between',
  gap: 8,
});

const submenuItemStyle = css({
  fontSize: '12px',
});

type MapContextMenuProps = Readonly<{
  map: google.maps.Map;
  menuPosition: {x: number; y: number};

  onHide: () => void;

  onAddDtp?: () => void;
  onAddRadius?: () => void;
  onBringToFront?: () => void;
  onBringGroupToFront?: () => void;
  onResetAllBringToFront?: () => void;
  onRemoveFromBringToFront?: () => void;
  onMoveMarkers?: () => void;
  onMoveMarkerLabels?: () => void;
}>;

export const MapMarkerContextMenuComponent: FC<MapContextMenuProps> = (props) => {
  const [t] = useTranslation();

  return (
    <div>
      <ContextMenuComponent
        isVisible
        onHide={props.onHide}
        preferredPlacement="bottom-start"
        renderMenuContent={() => (
          <>
            {props.onMoveMarkers && (
              <ContextMenuItemCoreComponent>
                <ContextMenuDefaultItem
                  itemStyle={menuItemStyle}
                  onClick={props.onMoveMarkers}
                >
                  {t('Move Markers')}
                </ContextMenuDefaultItem>
              </ContextMenuItemCoreComponent>
            )}
            {props.onMoveMarkerLabels && (
              <ContextMenuItemCoreComponent>
                <ContextMenuDefaultItem
                  itemStyle={menuItemStyle}
                  onClick={props.onMoveMarkerLabels}
                >
                  {t('Reposition Labels')}
                </ContextMenuDefaultItem>
              </ContextMenuItemCoreComponent>
            )}
            {props.onBringToFront && (
              <ContextMenuItemCoreComponent>
                <ContextMenuDefaultItem
                  itemStyle={menuItemStyle}
                  onClick={props.onBringToFront}
                >
                  {t('bringToFront.oneMarker')}
                </ContextMenuDefaultItem>
              </ContextMenuItemCoreComponent>
            )}
            {props.onBringGroupToFront && (
              <ContextMenuItemCoreComponent>
                <ContextMenuDefaultItem
                  itemStyle={menuItemStyle}
                  onClick={props.onBringGroupToFront}
                >
                  {t('bringToFront.allInGroup')}
                </ContextMenuDefaultItem>
              </ContextMenuItemCoreComponent>
            )}
            {(props.onRemoveFromBringToFront || props.onResetAllBringToFront) && (
              <ContextMenuItemCoreComponent
                renderSubmenu={() => (
                  <>
                    {props.onRemoveFromBringToFront && (
                      <ContextMenuItemCoreComponent>
                        <ContextMenuDefaultItem
                          itemStyle={submenuItemStyle}
                          onClick={props.onRemoveFromBringToFront}
                        >
                          {t('Reset for this Marker')}
                        </ContextMenuDefaultItem>
                      </ContextMenuItemCoreComponent>
                    )}
                    {props.onResetAllBringToFront && (
                      <ContextMenuItemCoreComponent>
                        <ContextMenuDefaultItem
                          itemStyle={submenuItemStyle}
                          onClick={props.onResetAllBringToFront}
                        >
                          {t('Reset All')}
                        </ContextMenuDefaultItem>
                      </ContextMenuItemCoreComponent>
                    )}
                  </>
                )}
              >
                <ContextMenuDefaultItem itemStyle={menuItemStyle}>
                  {t('bringToFront.reset')}
                  <FontAwesomeIcon icon={faChevronRight} />
                </ContextMenuDefaultItem>
              </ContextMenuItemCoreComponent>
            )}
            {props.onAddRadius && (
              <ContextMenuItemCoreComponent>
                <ContextMenuDefaultItem
                  itemStyle={menuItemStyle}
                  onClick={props.onAddRadius}
                >
                  {t('Add Radius')}
                </ContextMenuDefaultItem>
              </ContextMenuItemCoreComponent>
            )}

            {props.onAddDtp && (
              <ContextMenuItemCoreComponent>
                <ContextMenuDefaultItem
                  itemStyle={menuItemStyle}
                  onClick={props.onAddDtp}
                >
                  {t('Add Drive Time Polygon')}
                </ContextMenuDefaultItem>
              </ContextMenuItemCoreComponent>
            )}
          </>
        )}
      >
        {ref => (
          <span
            ref={ref}
            css={menuTriggerStyle(props.menuPosition)}
          />
        )}
      </ContextMenuComponent>
    </div>
  );
};
